import React from 'react';
import '../../App.css';
import './MainHeroSection.css';

function HeroSection() {
    return (
        <div className='hero-wrap'>
            <div className='hero-container'>
                <div className='hero-content'>
                    <div className='text-content'>
                    <h1>
                        <span className="highlight-white">Start</span>{' '}
                        <span className="highlight-orange">Fresh</span>{' '}
                        <span className="highlight-white">Every</span>{' '}
                        <span className="highlight-orange">Morning</span>{' '}
                        <span className="highlight-white">Here</span>
                    </h1>
                    <p>
                        At Egg House Cafe, we serve comfort and flavor in every bite. Whether you're fueling up for the day or craving a cozy brunch, we've got your perfect plate waiting.
                    </p>
                    <div className="hero-buttons">
                        <a href="/menu" className="btn-orange">
                            Online Ordering
                        </a>
                        <a href="/menu" className="btn-dark">
                            View Menu
                        </a>
                        </div>
                    </div>
                    <div className='hero-image'></div>
                </div>
            </div>
        </div>
    );
}

export default HeroSection;